/* Calmwave theme scripts — vanilla, no dependencies. */
(function () {
  'use strict';

  var S = window.themeSettings || {};
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var animOn = S.animEnabled && !reduced;

  /* ---------------------------------------------------------------- utils */
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function on(el, ev, fn, opt) { if (el) el.addEventListener(ev, fn, opt); }
  function debounce(fn, ms) { var t; return function () { var a = arguments, c = this; clearTimeout(t); t = setTimeout(function () { fn.apply(c, a); }, ms || 120); }; }

  function money(cents) {
    var fmt = S.moneyFormat || '${{amount}}';
    var amt = (cents / 100).toFixed(2);
    var parts = amt.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/\{\{\s*amount\s*\}\}/, parts.join('.'))
              .replace(/\{\{\s*amount_no_decimals\s*\}\}/, parts[0])
              .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, parts.join(',').replace(/,(\d{3})/g, '.$1'))
              .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, parts[0]);
  }

  var toastTimer;
  function toast(msg) {
    var t = document.getElementById('Toast');
    if (!t) return;
    t.textContent = msg;
    t.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove('is-visible'); }, 2600);
  }
  window.themeToast = toast;

  /* ------------------------------------------------------- 1. reveals */
  var revealIO = null;
  function initReveals(root) {
    var scope = root || document;
    var items = $$('.reveal', scope);
    if (!items.length) return;

    if (!animOn) { items.forEach(function (el) { el.classList.add('is-in'); }); return; }

    $$('[data-anim-scope]', scope).forEach(function (s) { s.classList.add('anim-on'); });
    if (scope !== document && scope.hasAttribute && scope.hasAttribute('data-anim-scope')) scope.classList.add('anim-on');

    if (!revealIO) {
      revealIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          e.target.classList.add('is-in');
          revealIO.unobserve(e.target);
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    }

    items.forEach(function (el) {
      if (el.classList.contains('is-in')) return;
      if (!el.getAttribute('data-anim')) el.setAttribute('data-anim', S.animStyle || 'rise');
      revealIO.observe(el);
    });
  }

  /* ------------------------------------------------------ 2. counters */
  function initCounters(root) {
    var els = $$('[data-count-to]', root || document);
    if (!els.length) return;
    if (!animOn || !S.animCounters) {
      els.forEach(function (el) { el.textContent = el.getAttribute('data-count-prefix') || '';
        el.textContent += el.getAttribute('data-count-to') + (el.getAttribute('data-count-suffix') || ''); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        io.unobserve(e.target);
        runCount(e.target);
      });
    }, { threshold: 0.4 });
    els.forEach(function (el) { io.observe(el); });
  }

  function runCount(el) {
    var target = parseFloat(el.getAttribute('data-count-to')) || 0;
    var dec = parseInt(el.getAttribute('data-count-decimals') || '0', 10);
    var pre = el.getAttribute('data-count-prefix') || '';
    var suf = el.getAttribute('data-count-suffix') || '';
    var dur = parseInt(el.getAttribute('data-count-duration') || '1600', 10);
    var start = performance.now();
    function frame(now) {
      var p = Math.min((now - start) / dur, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      var val = (target * eased).toFixed(dec);
      el.textContent = pre + Number(val).toLocaleString(undefined, { minimumFractionDigits: dec, maximumFractionDigits: dec }) + suf;
      if (p < 1) requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);
  }

  /* ------------------------------------------------- 3. bars & rings */
  function initMeters(root) {
    var els = $$('[data-meter]', root || document);
    if (!els.length) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        io.unobserve(e.target);
        var el = e.target;
        var pct = Math.max(0, Math.min(100, parseFloat(el.getAttribute('data-meter')) || 0));
        if (el.classList.contains('bar__fill')) {
          el.style.width = pct + '%';
        } else if (el.classList.contains('ring__fg')) {
          var C = 339.3;
          el.style.strokeDashoffset = String(C - (C * pct / 100));
        }
      });
    }, { threshold: 0.35 });
    els.forEach(function (el) {
      if (!animOn) {
        var pct = parseFloat(el.getAttribute('data-meter')) || 0;
        if (el.classList.contains('bar__fill')) el.style.width = pct + '%';
        else el.style.strokeDashoffset = String(339.3 - (339.3 * pct / 100));
        return;
      }
      io.observe(el);
    });
  }

  /* ------------------------------------------------------ 4. parallax */
  var parallaxEls = [];
  function initParallax(root) {
    if (!animOn || !S.animParallax) return;
    $$('[data-parallax]', root || document).forEach(function (el) {
      if (parallaxEls.indexOf(el) === -1) parallaxEls.push(el);
    });
    if (parallaxEls.length && !window.__pxBound) {
      window.__pxBound = true;
      var ticking = false;
      function run() {
        var vh = window.innerHeight;
        parallaxEls.forEach(function (el) {
          var r = el.getBoundingClientRect();
          if (r.bottom < -200 || r.top > vh + 200) return;
          var amt = parseFloat(el.getAttribute('data-parallax')) || 12;
          var progress = (r.top + r.height / 2 - vh / 2) / vh;
          el.style.transform = 'translate3d(0,' + (progress * amt * -1).toFixed(2) + 'px,0) scale(1.08)';
        });
        ticking = false;
      }
      window.addEventListener('scroll', function () {
        if (!ticking) { ticking = true; requestAnimationFrame(run); }
      }, { passive: true });
      run();
    }
  }

  /* -------------------------------------------------------- 5. header */
  function initHeader() {
    var header = $('[data-header]');
    if (!header) return;
    var last = window.scrollY;
    var hideOnScroll = header.getAttribute('data-hide-on-scroll') === 'true';
    function upd() {
      var y = window.scrollY;
      header.classList.toggle('is-stuck', y > 8);
      if (hideOnScroll) {
        var open = document.body.classList.contains('is-locked');
        header.classList.toggle('is-hidden', !open && y > last && y > 260);
      }
      last = y;
    }
    window.addEventListener('scroll', upd, { passive: true });
    upd();
  }

  /* ------------------------------------------- 6. announcement rotator */
  function initAnnouncement(root) {
    $$('[data-rotator]', root || document).forEach(function (rot) {
      var msgs = $$('.announcement__msg', rot);
      if (msgs.length < 2) { if (msgs[0]) msgs[0].classList.add('is-active'); return; }
      var i = 0;
      msgs[0].classList.add('is-active');
      var delay = parseInt(rot.getAttribute('data-rotator') || '5000', 10);
      setInterval(function () {
        msgs[i].classList.remove('is-active');
        i = (i + 1) % msgs.length;
        msgs[i].classList.add('is-active');
      }, delay);
    });
  }

  /* ------------------------------------------------------- 7. drawers */
  var lastFocused = null;
  function openDrawer(id) {
    var d = document.getElementById(id);
    if (!d) return;
    lastFocused = document.activeElement;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.body.classList.add('is-locked');
    $$('[aria-controls="' + id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    var focusable = $('button, a, input, select, textarea', d);
    if (focusable) setTimeout(function () { focusable.focus(); }, 260);
  }
  function closeDrawer(d) {
    if (!d) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('is-locked');
    $$('[aria-controls="' + d.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    if (lastFocused) lastFocused.focus();
  }
  window.themeOpenDrawer = openDrawer;

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-drawer-open]');
    if (opener) {
      e.preventDefault();
      openDrawer(opener.getAttribute('data-drawer-open'));
      return;
    }
    var closer = e.target.closest('[data-drawer-close]');
    if (closer) { e.preventDefault(); closeDrawer(closer.closest('.drawer')); return; }
    if (e.target.classList && e.target.classList.contains('drawer__overlay')) closeDrawer(e.target.closest('.drawer'));
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var open = $('.drawer.is-open');
    if (open) closeDrawer(open);
  });

  /* --------------------------------------------- 8. nav + faq toggles */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-submenu-toggle]');
    if (t) {
      e.preventDefault();
      var li = t.closest('li');
      var open = li.classList.toggle('is-open');
      t.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
  });

  function initFaq(root) {
    $$('[data-faq]', root || document).forEach(function (item) {
      var btn = $('.faq__q', item);
      var panel = $('.faq__a', item);
      if (!btn || !panel || btn.dataset.bound) return;
      btn.dataset.bound = '1';
      on(btn, 'click', function () {
        var isOpen = item.classList.contains('is-open');
        var group = item.closest('[data-faq-group]');
        if (group && group.getAttribute('data-faq-group') === 'single' && !isOpen) {
          $$('[data-faq].is-open', group).forEach(function (o) {
            o.classList.remove('is-open');
            $('.faq__q', o).setAttribute('aria-expanded', 'false');
            $('.faq__a', o).style.height = '0px';
          });
        }
        item.classList.toggle('is-open', !isOpen);
        btn.setAttribute('aria-expanded', !isOpen ? 'true' : 'false');
        panel.style.height = !isOpen ? panel.scrollHeight + 'px' : '0px';
      });
      if (item.classList.contains('is-open')) {
        panel.style.height = panel.scrollHeight + 'px';
        btn.setAttribute('aria-expanded', 'true');
      }
    });
    window.addEventListener('resize', debounce(function () {
      $$('[data-faq].is-open .faq__a').forEach(function (p) { p.style.height = p.scrollHeight + 'px'; });
    }, 180));
  }

  /* -------------------------------------- 9. horizontal scroller dots */
  function initScrollers(root) {
    $$('[data-scroller]', root || document).forEach(function (wrap) {
      var view = $('.hscroll, .gallery__viewport', wrap);
      var dots = $('.dots', wrap);
      if (!view) return;
      var items = $$('.hscroll__item, .gallery__slide', view);
      if (!items.length) return;

      if (dots && !dots.children.length) {
        items.forEach(function (_, i) {
          var b = document.createElement('button');
          b.type = 'button';
          b.setAttribute('aria-label', 'Go to slide ' + (i + 1));
          if (i === 0) b.classList.add('is-active');
          on(b, 'click', function () {
            view.scrollTo({ left: items[i].offsetLeft - view.offsetLeft, behavior: reduced ? 'auto' : 'smooth' });
          });
          dots.appendChild(b);
        });
      }

      var thumbs = $$('[data-thumb]', wrap);
      function setActive(idx) {
        if (dots) $$('button', dots).forEach(function (b, i) { b.classList.toggle('is-active', i === idx); });
        thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === idx); });
        wrap.setAttribute('data-active-index', idx);
      }
      thumbs.forEach(function (t, i) {
        on(t, 'click', function () {
          view.scrollTo({ left: items[i].offsetLeft - view.offsetLeft, behavior: reduced ? 'auto' : 'smooth' });
          setActive(i);
        });
      });

      on(view, 'scroll', debounce(function () {
        var mid = view.scrollLeft + view.clientWidth / 2;
        var best = 0, bestD = Infinity;
        items.forEach(function (it, i) {
          var c = it.offsetLeft - view.offsetLeft + it.clientWidth / 2;
          var d = Math.abs(c - mid);
          if (d < bestD) { bestD = d; best = i; }
        });
        setActive(best);
      }, 90), { passive: true });
    });
  }

  /* ------------------------------ 10. scroll-linked step / media sync */
  function initScrollSync(root) {
    $$('[data-sync]', root || document).forEach(function (wrap) {
      var items = $$('[data-sync-item]', wrap);
      var medias = $$('[data-sync-media]', wrap);
      if (!items.length) return;

      function activate(i) {
        items.forEach(function (it, n) { it.classList.toggle('is-active', n === i); });
        medias.forEach(function (m, n) { m.classList.toggle('is-shown', n === i); });
      }
      activate(0);

      if (!('IntersectionObserver' in window)) return;
      var io = new IntersectionObserver(function (entries) {
        var visible = entries.filter(function (e) { return e.isIntersecting; });
        if (!visible.length) return;
        visible.sort(function (a, b) { return b.intersectionRatio - a.intersectionRatio; });
        activate(items.indexOf(visible[0].target));
      }, { rootMargin: '-40% 0px -40% 0px', threshold: [0.1, 0.5, 0.9] });
      items.forEach(function (it) { io.observe(it); });
    });
  }

  /* ------------------------------------------------- 11. video cards */
  function initVideos(root) {
    $$('[data-vcard]', root || document).forEach(function (card) {
      var btn = $('.vcard__play', card);
      var vid = $('video', card);
      if (!btn || !vid || btn.dataset.bound) return;
      btn.dataset.bound = '1';
      on(btn, 'click', function () {
        if (vid.paused) {
          $$('[data-vcard] video').forEach(function (v) { if (v !== vid) { v.pause(); v.closest('[data-vcard]').classList.remove('is-playing'); } });
          vid.play();
          card.classList.add('is-playing');
          vid.controls = true;
        } else { vid.pause(); card.classList.remove('is-playing'); }
      });
      on(vid, 'ended', function () { card.classList.remove('is-playing'); vid.controls = false; });
    });
  }

  /* ---------------------------------------------------- 12. cart core */
  function refreshCart(openAfter) {
    return fetch('?section_id=cart-drawer', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = $('[data-cart-contents]', doc);
        var current = $('[data-cart-contents]');
        if (fresh && current) current.innerHTML = fresh.innerHTML;
        return fetch('/cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        $$('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          if (cart.item_count > 0) el.removeAttribute('hidden'); else el.setAttribute('hidden', '');
        });
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
        if (openAfter && S.cartType === 'drawer') openDrawer('CartDrawer');
        return cart;
      })
      .catch(function () {});
  }
  window.themeRefreshCart = refreshCart;

  function addToCart(id, qty, btn) {
    if (btn) { btn.setAttribute('aria-disabled', 'true'); btn.dataset.label = btn.textContent; btn.textContent = '…'; }
    return fetch(S.routes.cartAdd, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: qty || 1 }] })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status) { toast(data.description || data.message); return; }
        if (btn) { btn.textContent = S.strings.added; setTimeout(function () { btn.textContent = btn.dataset.label; }, 1500); }
        if (S.cartType === 'drawer') refreshCart(true); else window.location = S.routes.cart;
      })
      .catch(function () { toast('Something went wrong. Try again.'); })
      .finally(function () { if (btn) btn.removeAttribute('aria-disabled'); });
  }
  window.themeAddToCart = addToCart;

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-product-form]');
    if (!form) return;
    e.preventDefault();
    var idInput = $('[name="id"]', form);
    var qtyInput = $('[name="quantity"]', form);
    var btn = $('[data-atc]', form);
    if (!idInput || !idInput.value) return;
    addToCart(idInput.value, qtyInput ? parseInt(qtyInput.value, 10) : 1, btn);
  });

  document.addEventListener('click', function (e) {
    var qb = e.target.closest('[data-qty-change]');
    if (qb) {
      var wrap = qb.closest('.qty');
      var input = $('input', wrap);
      var next = Math.max(parseInt(input.getAttribute('min') || '1', 10), (parseInt(input.value, 10) || 1) + parseInt(qb.getAttribute('data-qty-change'), 10));
      input.value = next;
      input.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }
    var rm = e.target.closest('[data-cart-remove]');
    if (rm) { e.preventDefault(); changeLine(rm.getAttribute('data-line'), 0); return; }
    var quick = e.target.closest('[data-quick-add]');
    if (quick) { e.preventDefault(); addToCart(quick.getAttribute('data-quick-add'), 1, quick); }
  });

  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-cart-qty]');
    if (!input) return;
    changeLine(input.getAttribute('data-line'), parseInt(input.value, 10));
  });

  function changeLine(line, qty) {
    fetch(S.routes.cartChange, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty })
    }).then(function () {
      if (document.body.classList.contains('template-cart')) window.location.reload();
      else refreshCart(false);
    });
  }

  /* --------------------------------------------- 13. product variants */
  function initProductForms(root) {
    $$('[data-variant-picker]', root || document).forEach(function (picker) {
      if (picker.dataset.bound) return;
      picker.dataset.bound = '1';
      var section = picker.closest('[data-product-section]');
      var dataEl = $('[data-variant-json]', section);
      if (!dataEl) return;
      var variants = JSON.parse(dataEl.textContent);

      function currentOptions() {
        var opts = [];
        $$('[data-option-index]', picker).forEach(function (input) {
          if (input.type === 'radio' && !input.checked) return;
          var idx = parseInt(input.getAttribute('data-option-index'), 10);
          opts[idx] = input.value;
        });
        return opts;
      }

      function update() {
        var opts = currentOptions();
        var match = variants.find(function (v) {
          return opts.every(function (o, i) { return o == null || v.options[i] === o; });
        });
        var btn = $('[data-atc]', section);
        var idInput = $('[name="id"]', section);
        var priceNow = $('[data-price-now]', section);
        var priceWas = $('[data-price-was]', section);
        var saveEl = $('[data-price-save]', section);

        $$('[data-selected-value]', picker).forEach(function (el) {
          var i = parseInt(el.getAttribute('data-selected-value'), 10);
          if (opts[i]) el.textContent = opts[i];
        });

        if (!match) {
          if (btn) { btn.setAttribute('aria-disabled', 'true'); btn.textContent = S.strings.unavailable; }
          return;
        }
        if (idInput) idInput.value = match.id;
        if (priceNow) priceNow.textContent = money(match.price);
        if (priceWas) {
          if (match.compare_at_price && match.compare_at_price > match.price) {
            priceWas.textContent = money(match.compare_at_price);
            priceWas.hidden = false;
            if (saveEl) { saveEl.textContent = 'Save ' + money(match.compare_at_price - match.price); saveEl.hidden = false; }
          } else {
            priceWas.hidden = true;
            if (saveEl) saveEl.hidden = true;
          }
        }
        if (btn) {
          if (match.available) { btn.removeAttribute('aria-disabled'); btn.textContent = S.strings.addToCart + ' · ' + money(match.price); }
          else { btn.setAttribute('aria-disabled', 'true'); btn.textContent = S.strings.soldOut; }
        }
        $$('[data-sticky-price]').forEach(function (el) { el.textContent = money(match.price); });

        if (match.featured_media_index != null) {
          var gallery = $('[data-scroller] .gallery__viewport', section);
          if (gallery) {
            var slides = $$('.gallery__slide', gallery);
            var target = slides[match.featured_media_index];
            if (target) gallery.scrollTo({ left: target.offsetLeft - gallery.offsetLeft, behavior: reduced ? 'auto' : 'smooth' });
          }
        }
        if (history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', match.id);
          history.replaceState({}, '', url.toString());
        }
      }

      on(picker, 'change', update);
      update();
    });
  }

  /* -------------------------------------------------- 14. sticky ATC */
  function initStickyAtc(root) {
    var bar = $('[data-sticky-atc]', root || document);
    if (!bar) return;
    var anchor = $('[data-atc-anchor]');
    if (!anchor) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { bar.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0); });
    }, { threshold: 0 });
    io.observe(anchor);
    on($('[data-sticky-atc-btn]', bar), 'click', function () {
      var form = $('[data-product-form]');
      if (form) form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
    });
  }

  /* ------------------------------------------------- 15. newsletter */
  function initNewsletterState() {
    if (window.location.search.indexOf('customer_posted=true') > -1) {
      var el = $('[data-newsletter-success]');
      if (el) el.hidden = false;
    }
  }


  /* ------------------------------------------- 17. review wall + popup */
  var rvModal = null;
  var rvLastFocus = null;

  function rvGetModal() {
    if (rvModal && document.body.contains(rvModal)) return rvModal;
    var m = document.createElement('div');
    m.className = 'rv-modal';
    m.hidden = true;
    m.innerHTML =
      '<div class="rv-modal__backdrop" data-rv-close></div>' +
      '<div class="rv-modal__panel" role="dialog" aria-modal="true" aria-label="Customer review">' +
        '<button type="button" class="rv-modal__close" data-rv-close aria-label="Close">' +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg>' +
        '</button>' +
        '<div class="rv-modal__body"></div>' +
      '</div>';
    document.body.appendChild(m);
    m.addEventListener('click', function (e) {
      if (e.target.closest('[data-rv-close]')) rvCloseModal();
    });
    document.addEventListener('keydown', function (e) {
      if (!m.hidden && e.key === 'Escape') rvCloseModal();
    });
    rvModal = m;
    return m;
  }

  function rvOpenModal(card) {
    var m = rvGetModal();
    var body = m.querySelector('.rv-modal__body');
    var clone = card.cloneNode(true);
    ['tabindex', 'role', 'aria-label', 'data-rv-card'].forEach(function (a) { clone.removeAttribute(a); });
    Array.prototype.slice.call(clone.attributes).forEach(function (a) {
      if (a.name.indexOf('data-shopify-editor') === 0) clone.removeAttribute(a.name);
    });
    clone.classList.add('is-open');
    body.innerHTML = '';
    body.appendChild(clone);
    rvLastFocus = document.activeElement;
    m.hidden = false;
    m.querySelector('.rv-modal__panel').scrollTop = 0;
    document.documentElement.classList.add('rv-lock');
    m.querySelector('.rv-modal__close').focus();
  }

  function rvCloseModal() {
    if (!rvModal || rvModal.hidden) return;
    rvModal.hidden = true;
    document.documentElement.classList.remove('rv-lock');
    if (rvLastFocus && rvLastFocus.focus) rvLastFocus.focus();
  }

  function initReviewWall(root) {
    $$('[data-review-wall]', root || document).forEach(function (wall) {
      if (wall.dataset.rvReady === '1') return;
      wall.dataset.rvReady = '1';

      var src = $('[data-rv-source]', wall);
      var colsWrap = $('[data-rv-columns]', wall);
      var moreBtn = $('[data-rv-more]', wall);
      if (!src || !colsWrap) return;

      var all = $$('.rvcard', src);
      var initial = parseInt(wall.getAttribute('data-initial'), 10) || 6;
      var step = parseInt(wall.getAttribute('data-step'), 10) || 6;
      var loop = wall.getAttribute('data-loop') === 'true';
      var expand = wall.getAttribute('data-expand') || 'modal';
      var shown = 0;
      var cursor = 0;

      function colCount() {
        var w = window.innerWidth;
        var max = parseInt(colsWrap.getAttribute('data-cols'), 10) || 3;
        if (w < 750) return 1;
        if (w < 990) return 2;
        return max;
      }

      function render() {
        var n = colCount();
        colsWrap.innerHTML = '';
        var cols = [];
        for (var i = 0; i < n; i++) {
          var c = document.createElement('div');
          c.className = 'rvwall__col';
          colsWrap.appendChild(c);
          cols.push(c);
        }
        for (var j = 0; j < shown; j++) {
          var card = all[j % all.length].cloneNode(true);
          card.removeAttribute('data-shopify-editor-block');
          prep(card);
          cols[j % n].appendChild(card);
        }
      }

      function prep(card) {
        var body = $('.rvcard__body', card);
        var btn = $('.rvcard__more', card);
        if (btn && body) {
          // only offer "read more" when the text is actually clipped
          requestAnimationFrame(function () {
            if (body.scrollHeight - body.clientHeight < 4) btn.style.display = 'none';
          });
          btn.addEventListener('click', function (e) {
            e.stopPropagation();
            if (expand === 'modal') rvOpenModal(card);
            else card.classList.add('is-open');
          });
        }
        if (expand === 'modal') {
          card.setAttribute('tabindex', '0');
          card.setAttribute('role', 'button');
          card.addEventListener('click', function () { rvOpenModal(card); });
          card.addEventListener('keydown', function (e) {
            if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); rvOpenModal(card); }
          });
        }
      }

      function syncMore() {
        if (!moreBtn) return;
        var exhausted = !loop && shown >= all.length;
        moreBtn.parentNode.style.display = (all.length <= initial && !loop) || exhausted ? 'none' : '';
      }

      if (moreBtn) {
        moreBtn.addEventListener('click', function () {
          if (!loop && shown >= all.length) return;
          shown = loop ? shown + step : Math.min(shown + step, all.length);
          cursor = shown;
          render();
          syncMore();
        });
      }

      var lastCols = colCount();
      window.addEventListener('resize', function () {
        var c = colCount();
        if (c !== lastCols) { lastCols = c; render(); }
      });

      shown = Math.min(initial, loop ? initial : all.length);
      render();
      syncMore();
      wall.classList.add('rvwall--' + (expand === 'modal' ? 'tap' : 'inline'));
    });
  }

  /* --------------------------------------------------------- 16. init */
  function initAll(root) {
    initReveals(root);
    initCounters(root);
    initMeters(root);
    initParallax(root);
    initAnnouncement(root);
    initFaq(root);
    initScrollers(root);
    initScrollSync(root);
    initVideos(root);
    initProductForms(root);
    initStickyAtc(root);
    initReviewWall(root);
  }

  function boot() {
    initHeader();
    initAll(document);
    initNewsletterState();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  /* Theme editor support */
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); initHeader(); });
  document.addEventListener('shopify:section:select', function (e) { initAll(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var b = e.target;
    if (b.closest('[data-sync]')) {
      var items = $$('[data-sync-item]', b.closest('[data-sync]'));
      var i = items.indexOf(b);
      if (i > -1) {
        items.forEach(function (it, n) { it.classList.toggle('is-active', n === i); });
        $$('[data-sync-media]', b.closest('[data-sync]')).forEach(function (m, n) { m.classList.toggle('is-shown', n === i); });
      }
    }
    if (b.hasAttribute('data-faq')) {
      var btn = $('.faq__q', b);
      if (btn && !b.classList.contains('is-open')) btn.click();
    }
  });
})();
